module.exports = __webpack_public_path__ + "1ed1bee7908a4a1e860605c1498534cb.svg";